import {I18n} from '@aws-amplify/core';

import {SimplePageHeader,} from '@flexinet/ui-components';
import {AiOutlineCreditCard} from 'react-icons/ai'
import {useVerifiedPermissions} from "../../../hooks/useVerifiedPermissions.ts";
import {rbacActions} from "../../../config/rbac/actions.ts";
import {ReloadRecordsButton} from "../buttons/ReloadRecordsButton.tsx";
import {DeleteRecordButton} from "../buttons/DeleteRecordButton.tsx";
import {AddRecordButton} from "../buttons/AddRecordButton.tsx";


const useTools = (selectedIds: string[], onDeleteComplete?: () => void) => {

    const {allowedActions} = useVerifiedPermissions()

    const tools = [<ReloadRecordsButton key='reload'/>];

    if (allowedActions.includes(rbacActions.DeleteCard)) {
        tools.push(<DeleteRecordButton key='delete' selectedIds={selectedIds} onDeleteComplete={onDeleteComplete}/>);
    }

    if (allowedActions.includes(rbacActions.CreateCard)) {
        tools.push(<AddRecordButton key='add'/>);
    }


    return tools;
};

interface IndexPageHeaderProps {
    selectedIds?: string[];
    onDeleteComplete?: () => void;
}

export const IndexPageHeader = ({selectedIds = [], onDeleteComplete}: IndexPageHeaderProps) => {
    return (
        <SimplePageHeader
            title={I18n.get('Cards')}
            icon={<AiOutlineCreditCard/>}
            tools={useTools(selectedIds, onDeleteComplete)}
        />
    );
};
